export default __webpack_public_path__ + "static/media/kayo_new.6ecf2502.png";